import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../auth/useAuthContext';
import { MockDataService } from '../services/mockData.service';
import useTillStore from '../providers/useTillStore';

interface PatientRouteWrapperProps {
  children: React.ReactNode;
  moduleType: 'dispense' | 'till';
}

const PatientRouteWrapper: React.FC<PatientRouteWrapperProps> = ({ children, moduleType }) => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { getMockDataForPatient } = useTillStore();

  useEffect(() => {
    // Only redirect if user is a patient and currently on list page
    if (user?.roleId === 'patient') {
      const isListPage = location.pathname.includes('/list');
      
      if (isListPage) {
        if (moduleType === 'dispense') {
          // Create mock dispense data and redirect to detail page
          const mockDispenseData = MockDataService.getMockDispenseData(user);
          const mockDispenseId = mockDispenseData[0]?.id || 1;
          navigate(`/dispense/${mockDispenseId}`, { 
            state: { 
              patientData: {
                name: user.name || `${user.firstName} ${user.lastName}`,
                phone: user.phone,
                email: user.email
              }
            },
            replace: true 
          });
        } else if (moduleType === 'till') {
          // Create mock till data and redirect to detail page
          const mockTillData = MockDataService.getMockTillData(user);
          const mockTillId = mockTillData[0]?.id || 1;
          navigate(`/till/${mockTillId}`, { 
            state: { 
              patientData: {
                name: user.name || `${user.firstName} ${user.lastName}`,
                phone: user.phone,
                email: user.email
              }
            },
            replace: true 
          });
        }
      }
    }
  }, [user, location.pathname, navigate, moduleType, getMockDataForPatient]);

  // For non-patient users or when not on list pages, render children normally
  return <>{children}</>;
};

export default PatientRouteWrapper;